module.exports = __webpack_public_path__ + "img/computer-office.1c68d5ff.png";